export const ROUTER_CONFIG = [
  {
    title: "客户详情",
    path: "/customer",
  },
  {
    title: "商品详情",
    path: "/product",
  },
  {
    title: "话术库",
    path: "/scriptLibrary",
  },
  {
    path: "/marketingMaterials/h5",
    title: "慧择",
  },
  {
    path: "/marketingMaterials",
    title: "营销素材库",
  },
  {
    path: "/group",
    title: "群详情",
  },
]
